import React from 'react'
import { FiLock } from "react-icons/fi";
import { useCheckout } from '../../functions/useCheckout';
import { LoadingOverlay } from '../../../../loading';

const CheckoutBox = ({ data, shipment, handleBuy, load }) => {
  return (
    <div className="sticky lg:top-10 lg:mt-[61px] h-fit ring-1 ring-neutral-300 px-10 py-5 w-full lg:max-w-[250px] xl:max-w-[350px] 2xl:max-w-[400px]">
      {load && <LoadingOverlay />}
      <div className="overview space-y-8 text-sm sm:text-base">
        <div className="space-y-4">
          <div className="space-y-1">
            <div className="flex justify-between">
                <p className="grow">Ordre</p>
                <p className="">{(Number(data.map((book) => book.dbBook.price).reduce((acc, price) => acc + price, 0)) / 100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
            </div>
            <div className="flex justify-between items-center">
                <p className="grow">Levering</p>
                <p className={shipment.some(a => a.deliveryType === 0) ? "text-neutral-100 text-sm" : ""}>{shipment.some(a => a.deliveryType === 0) ? "Vælg levering" : shipment.filter(a => a.deliveryType === 1).map((ss) => ss.price).reduce((acc, price) => acc + price, 0).toFixed(2).toString().replace(/\./g, ',') + " kr."}</p>
            </div>
            <div className="flex justify-between">
                <p className="grow">Gebyr</p>
                <p className="">{((Number(data.map((book) => book.dbBook.price).reduce((acc, price) => acc + price, 0)) / 100) * 0.1).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
            </div>
          </div>
          <hr></hr>
          <div className="total flex justify-between">
            <p className="grow font-semibold">I alt</p>
            <p className="font-bold">{((Number(data.map((book) => book.dbBook.price).reduce((acc, price) => acc + price, 0)) / 100)+(Number(data.map((book) => book.dbBook.price).reduce((acc, price) => acc + price, 0)) / 100) * 0.1+(shipment.filter(a => a.deliveryType === 1).map((ss) => ss.price).reduce((acc, price) => acc + price, 0))).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
          </div>
        </div>
        <div className="space-y-4">
          <div onClick={() => handleBuy()} className={`${(shipment.some(a => a.deliveryType === 0) || shipment.some(a => a.deliveryType === 2 && !a.pickup.available) || shipment.filter(a => a.deliveryType === 1).some(a => Object.keys(a.service_point).length === 0) || shipment.length === 0) ? "opacity-70 select-none" : "cursor-pointer hover:bg-pos-100"} text-white text-sm sm:text-base bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 px-5 py-2.5 text-center`}>Fortsæt</div>
          <div className="secure text-sm space-y-1">
            <div className="flex gap-2 items-center">
              <FiLock className="text-lg" />
              <p className="font-semibold">Sikker betaling med Stripe</p>
            </div>
            <p className="text-neutral-500">Du videresendes til Stripe, som håndtere betalingen sikkert og krypteret.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CheckoutBox